<div class="{{localService.selectedLanguageCode}}"
  *ngIf="localService.languageContent && localService.languageContent.whitelist">
  <div class="banner center" style="max-width:1200px;">
    <div class="row row_header">
      <div class="col-md-6">
        <div class="row">
          <div class="col-6">
            <i class="material-icons on_language_changed" style="float:left;"
              (click)="onLoad()">replay_circle_filled</i>
            <i class="material-icons" style="float:left;" (click)="onAddWhitelist()">note_add</i>
            {{localService.languageContent.whitelist.ph_num}}
          </div>
          <div class="col-6">
            {{localService.languageContent.whitelist.nme}}
          </div>
        </div>
      </div>
      <div class="col-md-6">
        <div class="row">
          <div class="col-6">
            {{localService.languageContent.whitelist.status}}
          </div>
          <div class="col-6">
            {{localService.languageContent.whitelist.cmt}}
          </div>
        </div>
      </div>
    </div>
    <div class="custom_rows_body" [ngStyle]="{'max-height' : maxBodyHeight + 'px'}" *ngIf="items && statuses">
      <div class="row styled_row" *ngFor="let item of items">
        <div class="col-md-6">
          <div class="row">
            <div class="col-6 en">
              {{item.v1}}
            </div>
            <div class="col-6">
              {{item.v2}}
            </div>
          </div>
        </div>
        <div class="col-md-6">
          <div class="row">
            <div class="col-6">
              <i class="material-icons icon_adjust" (click)="onAddWhitelist(item.key)">edit</i>
              {{getName(item.v4)}}
            </div>
            <div class="col-6">
              {{item.v3}}
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <span style="display: none;">
    <button class="on_as_country_changed" (click)="onChangeAsCountry()">As Country Changed</button>
  </span>
</div>